import React, { Component } from 'react';
import { useNavigate } from 'react-router-dom';
import { Title, Text, SimpleGrid, Button } from '@mantine/core';
import { Phone, Users, Megaphone, ChevronRight, Tag } from 'lucide-react';
import { NumberWidget } from '../components/NumberWidget';
import { StatsWidget } from '../components/StatsWidget';
import { RecentList } from '../components/RecentList';
export function DashboardPage() {
  const navigate = useNavigate();
  const numbers = [{
    phoneNumber: '+55 11 99999-9999',
    name: 'WhatsApp Principal',
    isActive: true,
    lastConnection: 'Hoje, 10:45',
    iconColor: '#0047AB'
  }, {
    phoneNumber: '+55 11 88888-8888',
    name: 'Atendimento',
    isActive: true,
    lastConnection: 'Hoje, 09:30',
    iconColor: '#00A86B'
  }, {
    phoneNumber: '+55 11 77777-7777',
    name: 'Comunicação',
    isActive: true,
    lastConnection: 'Hoje, 08:15',
    iconColor: '#FFCC00'
  }];
  const contactItems = [{
    title: 'João Silva',
    subtitle: '+55 11 97777-7777',
    date: 'Hoje, 11:30',
    icon: <Users size={18} data-id="element-363" />,
    type: 'contact' as const
  }, {
    title: 'Maria Oliveira',
    subtitle: '+55 11 96666-6666',
    date: 'Ontem, 15:45',
    icon: <Users size={18} data-id="element-364" />,
    type: 'contact' as const
  }, {
    title: 'Carlos Santos',
    subtitle: '+55 11 95555-5555',
    date: '22/05/2023, 14:20',
    icon: <Users size={18} data-id="element-365" />,
    type: 'contact' as const
  }];
  const campaignItems = [{
    title: 'Reunião Diretório Municipal',
    subtitle: 'Enviada para 150 filiados',
    date: 'Hoje, 09:00',
    status: 'Concluída',
    icon: <Megaphone size={18} data-id="element-366" />,
    type: 'campaign' as const
  }, {
    title: 'Convocação Assembleia',
    subtitle: 'Enviada para 75 filiados',
    date: 'Ontem, 14:30',
    status: 'Em andamento',
    icon: <Megaphone size={18} data-id="element-367" />,
    type: 'campaign' as const
  }, {
    title: 'Evento de Filiação',
    subtitle: 'Agendada para 45 contatos',
    date: 'Amanhã, 10:00',
    status: 'Agendada',
    icon: <Megaphone size={18} data-id="element-368" />,
    type: 'campaign' as const
  }];
  const handleNumberClick = (phoneNumber: string) => {
    navigate(`/campaigns?number=${encodeURIComponent(phoneNumber)}`);
  };
  return <div className="space-y-6" data-id="element-369">
      <div className="flex justify-between items-center" data-id="element-370">
        <div data-id="element-371">
          <Title order={2} className="text-primary" data-id="element-372">
            Dashboard
          </Title>
          <Text c="dimmed" data-id="element-373">Visão geral do seu sistema</Text>
        </div>
      </div>
      <div className="space-y-6" data-id="element-374">
        <div className="mt-6" data-id="element-375">
          <div className="flex items-center justify-between mb-4" data-id="element-376">
            <Title order={4} data-id="element-377">Seus Números</Title>
            <Button size="sm" rightSection={<ChevronRight size={16} data-id="element-379" />} onClick={() => navigate('/numbers')} radius="lg" styles={{
            root: {
              backgroundColor: 'transparent',
              border: '1px solid #0047AB',
              color: '#0047AB',
              height: '48px',
              '&:hover': {
                backgroundColor: '#E3F2FD'
              }
            }
          }} data-id="element-378">
              Ver todos
            </Button>
          </div>
          <SimpleGrid cols={{
          base: 1,
          sm: 2,
          lg: 3
        }} data-id="element-380">
            {numbers.map((number, index) => <NumberWidget key={index} {...number} onClick={() => handleNumberClick(number.phoneNumber)} data-id="element-381" />)}
          </SimpleGrid>
        </div>
        <SimpleGrid cols={{
        base: 1,
        sm: 2,
        lg: 3
      }} className="mt-8" data-id="element-382">
          <StatsWidget title="Listas" value={8} subtitle="5 listas ativas" icon={<Tag size={24} data-id="element-384" />} color="#9333EA" onClick={() => navigate('/lists')} data-id="element-383" />
          <StatsWidget title="Contatos" value={1250} subtitle="+15 novos hoje" icon={<Users size={24} data-id="element-386" />} color="#0047AB" data-id="element-385" />
          <StatsWidget title="Campanhas" value={24} subtitle="5 em andamento" icon={<Megaphone size={24} data-id="element-388" />} color="#00A86B" onClick={() => navigate('/campaigns')} data-id="element-387" />
        </SimpleGrid>
        <SimpleGrid cols={{
        base: 1,
        md: 2
      }} className="mt-8" data-id="element-389">
          <RecentList title="Contatos Recentes" items={contactItems} onViewAll={() => navigate('/lists')} data-id="element-390" />
          <RecentList title="Campanhas Recentes" items={campaignItems} onViewAll={() => navigate('/campaigns')} data-id="element-391" />
        </SimpleGrid>
      </div>
    </div>;
}